import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'

export default function withAuthentication(Component) {
    class AuthenticatedComponent extends React.Component {
      componentWillMount () {
        this.checkAuth(this.props.isAuthenticated)
      }

      componentWillReceiveProps (nextProps) {
        this.checkAuth(nextProps.isAuthenticated)
      }

      checkAuth (isAuthenticated) {
        if (!isAuthenticated) {
          const { location } = this.props
          let redirectAfterLogin = location.pathname + location.search
          browserHistory.push(`/login?next=${encodeURIComponent(redirectAfterLogin)}`)
        }
      }

      render () {
        return (
          <div>
            {this.props.isAuthenticated === true
                ? <Component {...this.props} />
                : null
            }
          </div>
        )
      }
    }

    const mapStateToProps = (state) => ({
      ...(state.authentication || {}),
    });

    return connect(mapStateToProps)(AuthenticatedComponent)
}


// WEBPACK FOOTER //
// ./src/decorators/withAuthentication.js